import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=48fbac2a&scoped=true&"
import script from "./Window.vue?vue&type=script&lang=js&"
export * from "./Window.vue?vue&type=script&lang=js&"
import style0 from "./Window.vue?vue&type=style&index=0&id=48fbac2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fbac2a",
  null
  
)

export default component.exports